<template>
  <dx-modal
    :value="true"
    title="Nota Fiscal Eletrônica"
    @input="close"
    size="lg"
    id="integration-fiscal-document-modal"
  >
    <st-tabs>
      <st-tab name="Configurações">
        <div class="columns mt-2">
          <div class="column col-4 form-group">
            <label class="form-label">CNPJ</label>
            <input
              class="form-input"
              type="text"
              :value="form.identity"
              v-mask-cnpj
              readonly
            >
          </div>
          <div class="column col-8 form-group">
            <label class="form-label">Razão social</label>
            <input
              class="form-input"
              type="text"
              :value="form.companyName"
              readonly
            >
          </div>
        </div>

        <div class="columns mt-2">
          <div
            class="column col-6 form-group"
            :class="{'has-error': $v.form.municipalRegistration.$error}"
          >
            <label
              for="municipal-registration"
              class="form-label"
            >* Inscrição Municipal</label>
            <input
              class="form-input"
              id="municipal-registration"
              type="text"
              v-model="form.municipalRegistration"
              placeholder="Inscrição Municipal"
            >
            <st-form-input-hint :validator="$v.form.municipalRegistration" />
          </div>

          <div class="column col-6 form-group">
            <label for="taxRegime" class="form-label">Incentivador Cultural</label>
            <select id="taxRegime" class="form-select" v-model="form.culturalIncentive">
              <option :value="false">Não</option>
              <option :value="true">Sim</option>
            </select>
          </div>

          <div
            class="column col-6 form-group"
            :class="{'has-error': $v.form.taxRegime.$error}"
          >
            <label for="taxRegime" class="form-label">* Regime Tributário</label>
            <select id="taxRegime" class="form-select" v-model="form.taxRegime">
              <option value="">[Selecione]</option>
              <option
                v-for="(text, value) in taxRegimes"
                :value="value"
                :key="value"
              >{{ text }}</option>
            </select>
            <st-form-input-hint :validator="$v.form.taxRegime" />
          </div>

          <div
            class="column col-6 form-group"
            :class="{'has-error': $v.form.specialTaxRegime.$error}"
          >
            <label
              for="specialTaxRegime"
              class="form-label"
            >Tipo do regime especial de tributação</label>
            <select id="specialTaxRegime" class="form-select" v-model="form.specialTaxRegime">
              <option value="">[Selecione]</option>
              <option
                v-for="item in specialTaxRegimes"
                :value="item.code"
                :key="item.code"
              >{{ item.description }}</option>
            </select>
            <st-form-input-hint :validator="$v.form.specialTaxRegime" />
          </div>
        </div>

        <div class="divider text-center" data-content="Serviço padrão"></div>

        <div class="columns">
          <div
            class="column col-3 form-group"
            :class="{'has-error': $v.form.service.municipalCode.$error}"
          >
            <label for="service-municipal-code" class="form-label">* Código Municipal</label>
            <input
              type="text"
              class="form-input"
              id="service-code"
              v-model="form.service.municipalCode"
              placeholder="Código de serviço"
            >
            <st-form-input-hint :validator="$v.form.service.municipalCode" />
          </div>
          <div
            class="column col-3 form-group"
            :class="{'has-error': $v.form.service.nbsCode.$error}"
          >
            <label for="service-nbs-code" class="form-label">* Código NBS</label>
            <input
              type="text"
              class="form-input"
              id="service-code"
              v-model="form.service.nbsCode"
              placeholder="Código de serviço"
            >
            <st-form-input-hint :validator="$v.form.service.nbsCode" />
          </div>
          <div class="column col-3 form-group">
            <label for="service-cnae" class="form-label">CNAE</label>
            <input
              type="text"
              class="form-input"
              id="service-cnae"
              v-model="form.service.cnae"
              placeholder="Código CNAE"
            >
          </div>
          <div
            class="column col-3 form-group"
            :class="{'has-error': $v.form.service.issRate.$error}"
          >
            <label for="iss-rate" class="form-label">* Alíquota ISS</label>
            <div class="input-group">
              <dx-input-number
                class="form-input"
                id="iss-rate"
                v-model="form.service.issRate"
                maxlength="5"
                :precision="2"
              />
              <span class="input-group-addon">%</span>
            </div>
            <st-form-input-hint :validator="$v.form.service.issRate" />
          </div>
          <div
            class="column form-group mb-2"
            :class="{'has-error': $v.form.service.description.$error}"
          >
            <label for="service-description" class="form-label">* Descrição</label>
            <textarea
              type="text"
              class="form-input"
              id="service-description"
              v-model="form.service.description"
              placeholder="Descrição do serviço"
            />
            <st-form-input-hint :validator="$v.form.service.description" />
          </div>
        </div>

        <div class="divider text-center" data-content="Nota fiscal de serviço"></div>

        <div class="columns">
          <div class="column form-group">
            <label for="" class="form-label">Série da NF</label>
            <input
              type="text"
              class="form-input"
              v-model="form.series"
            >
          </div>
          <div class="column form-group">
            <label for="" class="form-label">Sequencial</label>
            <input
              type="text"
              class="form-input"
              v-model="form.sequential"
            >
          </div>
        </div>
      </st-tab>

      <st-tab name="Dados de acesso" v-if="!loading && isSaved">
        <div class="digital-certificate-info" v-if="hasCertificate">
          <div class="mb-1">
            <strong>Certificado digital</strong>
          </div>
          <div>
            <span class="mr-1">Nome:</span>
            <strong>{{ certificate.name }}</strong>
          </div>
          <div>
            <span class="mr-1">Valido até:</span>
            <strong>{{ certificate.expiresAt | date }}</strong>
          </div>
        </div>


        <div class="upload-area mb-2" :class="{ dragging: certificate.dragging }">
          <input
            type="file"
            accept=".pfx,.p12"
            class="input-file"
            @dragenter="certificate.dragging = true"
            @dragleave="certificate.dragging = false"
            @drop="certificate.dragging = false"
            @change="certificateUploadChange"
          >
          <div class="upload-inner">
            <fa-icon :icon="['fal', 'upload']"></fa-icon>
            <p>
              Arraste seu certificado digital aqui
              ou clique para selecionar<br>
              <small>(Extensão PFX ou P12)</small>
            </p>
          </div>
        </div>

        <div class="form-group">
          <label for="certificate-name" class="form-label">Certificado digital</label>
          <input
            class="form-input"
            :value="certificate.file ? certificate.file.name : '--'"
            :readonly="true"
          >
        </div>

        <div
          class="form-group"
          :class="{ 'has-error': $v.certificate.password.$error }"
        >
          <label for="certificate-password" class="form-label">Senha do certificado</label>
          <st-input-password
            id="certificate-password"
            v-model="certificate.password"
            placeholder="******"
          />
          <st-form-input-hint :validator="$v.certificate.password" />
        </div>

        <div class="text-center p-2">
          <button
            type="button"
            class="btn btn-primary"
            :class="{ loading: certificate.uploading }"
            @click="uploadCertificate"
            :disabled="!canUploadCertificate || certificate.uploading"
          >{{ hasCertificate ? 'Atualizar certificado' : 'Enviar certificado' }}</button>
        </div>
      </st-tab>

      <st-tab name="Cadastro da empresa">
        <div class="columns mt-2">
          <div
            class="column col-4 form-group"
            :class="{'has-error': $v.form.identity.$error}"
          >
            <label for="identity" class="form-label">* CNPJ</label>
            <input
              class="form-input"
              id="identity"
              type="text"
              v-model="form.identity"
              placeholder="00.000.000/0000-00"
              v-mask-cnpj
            >
            <st-form-input-hint :validator="$v.form.identity" />
          </div>
          <div
            class="column col-8 form-group"
            :class="{'has-error': $v.form.companyName.$error}"
          >
            <label for="company-name" class="form-label">* Razão social</label>
            <input
              class="form-input"
              id="company-name"
              type="text"
              v-model="form.companyName"
              placeholder="Razão social"
            >
            <st-form-input-hint :validator="$v.form.companyName" />
          </div>
          <div
            class="column col-4 form-group"
            :class="{'has-error': $v.form.email.$error}"
          >
            <label for="email" class="form-label">* Email</label>
            <input
              class="form-input"
              id="email"
              type="text"
              v-model="form.email"
              placeholder="email@email.com"
            >
            <st-form-input-hint :validator="$v.form.email" />
          </div>
          <div
            class="column col-3 form-group"
            :class="{'has-error': $v.form.phone.$error}"
          >
            <label for="phone" class="form-label">Telefone</label>
            <input
              class="form-input"
              id="phone"
              type="text"
              v-model="form.phone"
              placeholder="(00) 0000-0000"
              v-mask-phone.br
            >
            <st-form-input-hint :validator="$v.form.phone" />
          </div>
          <div class="column col-5 form-group">
            <label for="name" class="form-label">Nome fantasia</label>
            <input
              class="form-input"
              id="name"
              type="text"
              v-model="form.name"
              placeholder="Nome fantasia"
            >
          </div>
        </div>

        <div class="columns mt-2">
          <div
            class="column col-4 form-group"
            :class="{'has-error': $v.form.address.postalCode.$error}"
          >
            <label for="address-postal-code" class="form-label">* CEP</label>
            <div class="input-group">
              <input
                class="form-input"
                id="address-postal-code"
                type="text"
                v-model="form.address.postalCode"
                @change="loadAddressByPostalCode"
                placeholder="00.000-000"
                v-mask-cep
              >
              <button
                type="button"
                class="btn input-group-btn btn-icon btn-action btn-gray-outline"
                :class="{ loading: loadingAddress }"
                @click="loadAddressByPostalCode"
                :disabled="loadingAddress"
              ><fa-icon :icon="['fal', 'search']" /></button>
            </div>
            <st-form-input-hint :validator="$v.form.address.postalCode" />
          </div>
          <div class="column col-8"></div>
          <div
            class="column col-6 form-group"
            :class="{'has-error': $v.form.address.street.$error}"
          >
            <label for="address-street" class="form-label">* Endereço</label>
            <input
              class="form-input"
              id="address-street"
              type="text"
              v-model="form.address.street"
              :disabled="!isPostalCodeValid"
              placeholder="Avenida Brasil"
            >
            <st-form-input-hint :validator="$v.form.address.street" />
          </div>
          <div
            class="column col-2 form-group"
            :class="{'has-error': $v.form.address.number.$error}"
          >
            <label for="address-number" class="form-label">* Número</label>
            <input
              class="form-input"
              id="address-number"
              type="text"
              v-model="form.address.number"
              :disabled="!isPostalCodeValid"
              placeholder="0"
            >
            <st-form-input-hint :validator="$v.form.address.number" />
          </div>
          <div class="column col-4 form-group">
            <label for="address-complement" class="form-label">Complemento</label>
            <input
              class="form-input"
              id="address-complement"
              type="text"
              v-model="form.address.complement"
              :disabled="!isPostalCodeValid"
              placeholder="Complemento"
            >
          </div>
          <div class="column col-4 form-group">
            <label for="address-neighborhood" class="form-label">Bairro</label>
            <input
              class="form-input"
              id="address-neighborhood"
              type="text"
              v-model="form.address.neighborhood"
              :disabled="!isPostalCodeValid"
              placeholder="Bairro"
            >
          </div>
          <div
            class="column col-4 form-group"
            :class="{'has-error': $v.form.address.city.$error}"
          >
            <label for="address-city" class="form-label">* Cidade</label>
            <input
              class="form-input"
              id="address-city"
              type="text"
              v-model="form.address.city"
              :disabled="!isPostalCodeValid"
              :readonly="isPostalCodeValid"
              placeholder="Cidade"
            >
            <st-form-input-hint :validator="$v.form.address.city" />
          </div>
          <div
            class="column col-4 form-group"
            :class="{'has-error': $v.form.address.state.$error}"
          >
            <label for="address-state" class="form-label">* Estado</label>
            <select
              id="address-state"
              name="address-state"
              class="form-select"
              :class="{ readonly: isPostalCodeValid }"
              v-model="form.address.state"
              :disabled="true"
            >
              <option value="">[Selecione]</option>
              <option v-for="(text, value) in states"
                      :value="value" :key="value">{{ text }}</option>
            </select>
            <st-form-input-hint :validator="$v.form.address.state" />
          </div>
        </div>
      </st-tab>
    </st-tabs>

    <template v-slot:footer>
      <button
        type="button"
        class="btn btn-primary"
        :class="{ loading: saving }"
        :disabled="saving"
        @click="save"
      >Salvar</button>
      <button
        type="button"
        class="btn ml-2"
        @click="close"
      >Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { mapState } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';
import { cnpj, cep, phone } from '@/data/validators';
import states from '@/data/states';
import { taxRegimes } from '@/data/fiscal-tax-regimes';
import { deepClone, mergeFrom } from '@/helpers/object';
import { clearNonNumbers } from '@/helpers/string';

export default {
  data() {
    return {
      loading: false,
      loadingAddress: false,
      saving: false,
      fillingOut: false,
      postCodeValidated: false,
      form: this.blankForm(),
      certificate: {
        file: null,
        password: '',
        dragging: false,
        uploading: false,
        name: '',
        expiresAt: '',
      },
      specialTaxRegimes: [],
      states,
      taxRegimes,
    };
  },
  validations() {
    return {
      form: {
        companyName: { required },
        identity: { required, cnpj },
        email: { required, email },
        phone: { phone },
        municipalRegistration: { required },
        taxRegime: { required },
        specialTaxRegime: { required },
        service: {
          municipalCode: { required },
          nbsCode: { required },
          description: { required },
          issRate: { required },
        },
        address: {
          postalCode: { required, cep },
          street: { required },
          number: { required },
          city: { required },
          state: { required },
        },
      },
      certificate: {
        password: { required },
      },
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    branch() {
      return this.user.branch;
    },
    isSaved() {
      return !!this.form.externalId;
    },
    hasCertificate() {
      return this.certificate.name && this.certificate.expiresAt;
    },
    canUploadCertificate() {
      return !this.$v.certificate.$error && this.certificate.file;
    },
    isPostalCodeValid() {
      return !this.$v.form.address.postalCode.$error && this.postCodeValidated;
    },
  },
  methods: {
    async load() {
      try {
        const { data } = await this.$http.get('/facility-settings/fiscal-document');
        if (data) {
          this.form = mergeFrom(this.blankForm(), data);
          if (!this.form.identity) {
            await this.fillForm();
          } else if (data.digitalCertificate) {
            this.certificate.name = data.digitalCertificate.name;
            this.certificate.expiresAt = data.digitalCertificate.expiresAt;
          }
          await this.loadParams();
        }
      } catch (e) {
        this.$toast.error(e);
      }
    },
    async loadParams() {
      try {
        const params = {
          state: this.form.address.state,
          city: this.form.address.city,
        };
        const { data } = await this.$http.get('/facility-settings/fiscal-document/params', { params });
        this.specialTaxRegimes = data.specialTaxRegimes;
        if (!this.form.specialTaxRegime && this.specialTaxRegimes.length > 0) {
          this.form.specialTaxRegime = this.specialTaxRegimes[0].code;
        }
      } catch (e) {
        this.$toast.error(e);
      }
    },
    validateForm() {
      this.$v.form.$touch();
      return !this.$v.form.$error;
    },
    validatePostalCode() {
      this.$v.form.address.postalCode.$touch();
      return !this.$v.form.address.postalCode.$error;
    },
    async save() {
      if (!this.validateForm()) {
        this.$toast.error('Existem erros de preenchimento');
        return;
      }

      this.saving = true;
      try {
        const postData = deepClone(this.form);
        postData.identity = clearNonNumbers(postData.identity);
        postData.address.postalCode = clearNonNumbers(postData.address.postalCode);
        const { data } = await this.$http.post('/facility-settings/fiscal-document', postData);
        this.form.externalId = data.externalId;
        this.$toast.success('Dados salvos com sucesso');
      } catch (e) {
        this.$toast.error(e);
      }
      this.saving = false;
    },
    certificateUploadChange(e) {
      e.preventDefault();
      if (e.target.files[0]) {
        ([this.certificate.file] = e.target.files);
      } else {
        this.certificate.file = null;
      }
    },
    async uploadCertificate() {
      this.$v.certificate.$touch();
      if (this.$v.certificate.$error) {
        return;
      }

      this.certificate.uploading = true;
      try {
        const formData = new FormData();
        formData.append('file', this.certificate.file);
        formData.append('password', this.certificate.password);
        await this.$http.post('/facility-settings/fiscal-document/certificate', formData);
        this.$toast.success('Certificado enviado com sucesso');
      } catch (e) {
        this.$toast.error(e);
      }
      this.certificate.uploading = false;
    },
    close() {
      this.$emit('close');
    },
    async fillForm() {
      this.fillingOut = true;
      try {
        const { data } = await this.$http.get(`/branches/${this.branch.id}?user=false`);
        this.form.companyName = data.companyName;
        this.form.identity = data.identity.value;
        this.form.name = data.name;
        this.form.email = data.email;
        this.form.phone = data.phone || data.cellphone;

        const [address] = data.addresses;
        if (address) {
          const [street, number] = address.addressLine1.split(',');
          this.form.address.postalCode = address.postalCode;
          this.form.address.street = street ? street.trim() : '';
          this.form.address.number = number ? number.trim() : '';
          this.form.address.complement = address.addressLine2;
          this.form.address.neighborhood = address.neighborhood;
          this.form.address.city = address.city;
          this.form.address.state = address.state;

          this.postCodeValidated = !!address.city && !!address.state;
        }
      } catch (e) {
        this.$toast.error(e);
      }
      this.fillingOut = false;
    },
    async loadAddressByPostalCode() {
      const postalCode = clearNonNumbers(this.form.address.postalCode);

      if (this.validatePostalCode() && postalCode.length === 8 && !this.loadingAddress) {
        this.loadingAddress = true;
        this.postCodeValidated = false;

        try {
          const data = await this.$cep.get(postalCode);
          this.form.address.city = data.city;
          this.form.address.state = data.state;
          this.form.address.neighborhood = data.neighborhood;
          this.form.address.street = data.street;

          this.postCodeValidated = !!data.city && !!data.state;
          if (!this.postCodeValidated) {
            this.$toast.error('CEP não encontrado');
          }
        } catch (e) {
          this.$toast.error(e);
        }

        this.loadingAddress = false;
      }
    },
    blankForm() {
      return {
        externalId: '',
        companyName: '', // Razão Social
        name: '', // Nome Fantasia
        identity: '',
        email: '',
        phone: '',
        stateRegistration: '',
        municipalRegistration: '',
        taxRegime: '',
        specialTaxRegime: '',
        culturalIncentive: false,
        service: {
          municipalCode: '',
          nbsCode: '',
          cnae: '',
          issRate: 0,
          description: '',
        },
        series: '1',
        sequential: 1,
        address: {
          postalCode: '',
          street: '',
          number: '',
          complement: '',
          neighborhood: '',
          city: '',
          state: '',
        },
      };
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

#integration-fiscal-document-modal {
  .modal .modal-container {
    max-width: 40rem;
  }

  .digital-certificate-info {
    background-color: rgba($info-color, .1);
    border: $border-width solid $info-color;
    border-radius: $border-radius;
    margin: $layout-spacing 0;
    padding: $layout-spacing;
    strong {
      font-weight: 600;
    }
  }

  .upload-area {
    align-items: center;
    background-color: lighten($gray-color-light, 5%);
    border: lighten($gray-color, 5%) $unit-h dashed;
    display: flex;
    height: 7rem;
    justify-content: center;
    margin-top: $layout-spacing;
    position: relative;
    &.dragging {
      border-color: $primary-color;
    }
    .input-file {
      display: block;
      height: 100%;
      left: 0;
      opacity: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
    .upload-inner {
      display: flex;
      align-items: center;
    }
    svg {
      font-size: 1.8rem;
    }
    p {
      margin: 0 0 0 $layout-spacing;
      text-align: center;
    }
  }
}
</style>
